import * as React from "react";
import {
  BreadcrumbLabelsContext,
  NO_BREADCRUMB_LABELS,
  SetBreadcrumbLabelContext,
  type SetBreadcrumbLabel,
} from "./useBreadcrumbLabels";

/**
 * Holds the names pages give to the ids of the current path, for the
 * breadcrumbs (QA-07); see `useBreadcrumbLabels`.
 */
export function BreadcrumbLabelsProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [labels, setLabels] =
    React.useState<ReadonlyMap<string, string>>(NO_BREADCRUMB_LABELS);
  const setLabel = React.useCallback<SetBreadcrumbLabel>((segment, label) => {
    setLabels((current) => {
      const unchanged =
        label === null ? !current.has(segment) : current.get(segment) === label;
      if (unchanged) return current;
      const next = new Map(current);
      if (label === null) next.delete(segment);
      else next.set(segment, label);
      return next;
    });
  }, []);

  return (
    <SetBreadcrumbLabelContext value={setLabel}>
      <BreadcrumbLabelsContext value={labels}>
        {children}
      </BreadcrumbLabelsContext>
    </SetBreadcrumbLabelContext>
  );
}
